import React, { useState, useEffect } from "react";
import { ArrowRight, X } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const projects = [{
  title: "Dự án Công ty Cổ Phần KCN Tân Vũ – Hải Phòng",
  description: "- Đặc điểm công trình: <br />&bull; Diện tích Giai đoạn 1: 10.6 ha<br />&bull; Vị trí: Lô CN4G, Khu công nghiệp Deep C-2B, Khu kinh tế Đình Vũ-Cát Hải, Hải Phòng.<br />&bull; <strong>Vai trò của Nucetech</strong>: tính toán thiết kế chịu lửa cho kết cấu thép của nhà bậc IV. Hạng mục: Nhà Kho A, Nhà Xưởng Hỗn Hợp B, Nhà Xưởng Hỗn Hợp C",
  images: ["https://nucectd.com/wp-content/uploads/2026/06/Picture17.png", "https://nucectd.com/wp-content/uploads/2026/06/Picture18.jpg"],
  href: "/ProjectsPage"
}, {
  title: "Dự án nhà máy sản xuất keo, chất kết dính và sản phẩm làm từ nhựa OKURA INDUSTRIAL CO.,LTD",
  description: "-	Đặc điểm công trình: <br />&bull; Quy mô diện tích: 51.787 m2<br />&bull; Vị trí: Lô CII-6, thuộc Khu công nghiệp và Khu phi thuế quan Sài Gòn – Chân Mây, huyện Phú Lộc, tỉnh Thừa Thiên Huế<br />&bull; <strong>Vai trò của Nucetech</strong>: thiết kế chịu lửa cho kết cấu thép. Hạng mục: Nhà xưởng và Nhà văn phòng.",
  images: ["https://nucectd.com/wp-content/uploads/2026/06/Picture19.png", "https://nucectd.com/wp-content/uploads/2026/06/Picture20.jpg"],
  href: "/ProjectsPage"
}, {
  title: "Công trình Nhà máy DRB Việt Nam 2",
  description: "- Đặc điểm công trình: <br />&bull; Quy mô diện tích: 65.540 m2<br />&bull; Địa điểm: Lô A-15A-CN, Đường N1, KCN Bàu Bàng, Thị trấn Lai Uyên, Huyện Bàu Bàng, Tỉnh Bình Dương<br />&bull; <strong>Vai trò của Nucetech/<strong>: thiết kế chịu lửa cho kết cấu thép",
  images: ["https://nucectd.com/wp-content/uploads/2026/06/Picture21.png", "https://nucectd.com/wp-content/uploads/2026/06/Picture22.jpg"],
  href: "/ProjectsPage"
}, {
  title: "DỰ ÁN KCN NHƠN TRẠCH 6D",
  description: "- Đặc điểm công trình: <br />&bull; Diện tích sàn: 40,000-60,000 m2<br />&bull; Địa điểm: KCN Nhơn Trạch 6D, Xã Long Thọ, Huyện Nhơn Trạch, Tỉnh Đồng Nai<br />&bull; <strong>Vai trò của Nucetech</strong>: tính toán thiết kế chịu lửa cho kết cấu thép của nhà bậc IV.",
  images: ["https://nucectd.com/wp-content/uploads/2026/06/Picture23.jpg", "https://nucectd.com/wp-content/uploads/2026/06/Picture24.png"],
  href: "/ProjectsPage"
}, {
  title: "DỰ ÁN KCN HỐ NAI 2 (16.8HA)",
  description: "- Đặc điểm công trình: <br />&bull; Diện tích: 16.8 ha<br />&bull; Địa điểm: Đường số 6, Giai đoạn 2, Khu công nghiệp Hố Nai, Phường Phước Tân, TP. Biên Hòa, Tỉnh Đồng Nai<br />&bull; <strong>Vai trò của Nucetech</strong>: tính toán thiết kế chịu lửa cho kết cấu thép.",
  images: ["https://nucectd.com/wp-content/uploads/2026/06/Picture25.png", "https://nucectd.com/wp-content/uploads/2026/06/Picture26.png", "https://nucectd.com/wp-content/uploads/2026/06/Picture27.jpg"],
  href: "/ProjectsPage"
}, {
  title: "DỰ ÁN KCN PHÚC ĐIỀN A8",
  description: "- Đặc điểm công trình: <br />&bull; Diện tích: 18,7 ha<br />&bull; Địa điểm: Lô A8, Đường Tỉnh 394B, KCN Phúc Điền Mở Rộng, Hải Phòng.<br />&bull;<strong> Vai trò của Nucetech</strong>: tính toán thiết kế chịu lửa cho kết cấu thép.",
  images: ["https://nucectd.com/wp-content/uploads/2026/06/Picture28.jpg", "https://nucectd.com/wp-content/uploads/2026/06/Picture29.png"],
  href: "/ProjectsPage"
}, {
  title: "CÔNG TRÌNH CÔNG TY TNHH MỘT THÀNH VIÊN HOÁ CHẤT ĐỨC GIANG LÀO CAI - KCN TẰNG LỎONG",
  description: "- Đặc điểm công trình: <br />&bull; Vị trí: Khu Công nghiệp Tằng Loỏng, Xã Tằng Loỏng, Huyện Bảo Thắng, Tỉnh Lào Cai.<br />&bull; <strong>Vai trò của Nucetech</strong>: tính toán thiết kế chịu lửa cho kết cấu thép hạng mục Phòng cháy chữa cháy.",
  images: ["https://nucectd.com/wp-content/uploads/2026/06/Picture30.jpg", "https://nucectd.com/wp-content/uploads/2026/06/Picture31.jpg", "https://nucectd.com/wp-content/uploads/2026/06/Picture32.jpg"],
  href: "/ProjectsPage"
}];
export default function ProjectsOverview() {
  const [selectedProject, setSelectedProject] = useState<typeof projects[0] | null>(null);
  const [isOpen, setIsOpen] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  useEffect(() => {
    if (!isOpen || !selectedProject || selectedProject.images.length <= 1) return;
    const interval = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % selectedProject.images.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [isOpen, selectedProject]);
  function handleOpen(project: typeof projects[0]) {
    setSelectedProject(project);
    setCurrentSlide(0);
    setIsOpen(true);
  }
  function handleClose() {
    setIsOpen(false);
    setSelectedProject(null);
  }
  return <section data-section-id="34927" id="project-showcase" ref={ref} className="bg-background text-foreground py-32 relative overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className={`mb-16 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <h2 className="text-4xl md:text-5xl font-default font-bold tracking-tight text-primary mb-6">Phần thiết kế chịu lửa cho kết cấu thép</h2>
          <p className="text-xl text-muted-foreground font-sans">
            
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {projects.map((project, i) => <div key={i} data-index={i} className={`transition-all duration-700 ease-[cubic-bezier(0.25,0.1,0.25,1)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-20"}`} style={{
          transitionDelay: `${i * 100}ms`
        }}>
<div onClick={() => handleOpen(project)} className="block h-full group cursor-pointer">
  <Card className="h-full border border-border bg-card shadow-xl rounded-lg overflow-hidden relative transition-all duration-500 ease-[cubic-bezier(0.25,0.1,0.25,1)] group-hover:border-primary/20">
    <div className="relative h-48 w-full overflow-hidden border-b border-border">
      <img src={project.images[0]} alt={project.title} className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" loading="lazy" />
    </div>

    <CardHeader className="pt-8 pb-2">
      <CardTitle className="font-default text-2xl font-bold text-primary group-hover:text-accent transition-colors">
        {project.title}
      </CardTitle>
    </CardHeader>

    <CardContent></CardContent>
  </Card>
</div>
            </div>)}
        </div>
      </div>

      {isOpen && selectedProject && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-background/50 backdrop-blur-sm" onClick={handleClose}>
          <div className="bg-white/95 border-[3px] border-black/30 shadow-[0_25px_80px_rgba(0,0,0,0.35)] max-w-2xl w-full rounded-2xl overflow-hidden relative backdrop-blur-xl" onClick={e => e.stopPropagation()}>
            <Button variant="ghost" size="icon" className="absolute top-4 right-4 z-10 rounded-lg" onClick={handleClose}>
              <X className="size-5" />
            </Button>
            
<div className="relative h-64 w-full p-3"> 
  <div className="w-full h-full overflow-hidden rounded-xl border border-black/10"> 
    <img key={currentSlide} src={selectedProject.images[currentSlide]} alt={selectedProject.title} className="w-full h-full object-cover animate-in fade-in zoom-in duration-700" /> 
  </div> 
</div>
            
            <div className="p-8">
              <h3 className="text-3xl font-default font-bold text-primary mb-4">
                {selectedProject.title}
              </h3>
              <p className="text-muted-foreground font-sans leading-relaxed mb-8" dangerouslySetInnerHTML={{
            __html: selectedProject.description
          }} />
              <div className="flex justify-end">
                <Button onClick={handleClose} className="rounded-lg">
                  Đóng
                </Button>
              </div>
            </div>
          </div>
        </div>}
    </section>;
}